// ---------- Nav solid state on scroll (homepage transparent hero) ----------
(function(){
  var nav = document.getElementById('siteNav');
  if (!nav) return;
  var transparent = nav.dataset.transparent === 'true';
  function updateNav(){
    if (!transparent || window.scrollY > 60) nav.classList.add('solid');
    else nav.classList.remove('solid');
  }
  if (transparent) {
    window.addEventListener('scroll', updateNav);
    updateNav();
  } else {
    nav.classList.add('solid');
  }
})();

// ---------- Mobile nav toggle ----------
(function(){
  var navToggle = document.getElementById('navToggle');
  var navLinks = document.getElementById('navLinks');
  if (!navToggle || !navLinks) return;
  navToggle.addEventListener('click', function(){ navLinks.classList.toggle('open'); });
  navLinks.querySelectorAll('a').forEach(function(a){
    a.addEventListener('click', function(){ navLinks.classList.remove('open'); });
  });
})();

// ---------- Shared accordion (FAQ + product details) ----------
(function(){
  document.querySelectorAll('.faq-q, .pd-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.parentElement;
      var group = item.parentElement;
      var wasOpen = item.classList.contains('open');
      group.querySelectorAll(':scope > .faq-item, :scope > .pd-item').forEach(function(i){ i.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
    });
  });
})();

// ---------- Film strip drag-to-scroll ----------
(function(){
  var strip = document.getElementById('filmstrip');
  if (!strip) return;
  var isDown = false, startX, scrollLeft;
  strip.addEventListener('mousedown', function(e){
    isDown = true; startX = e.pageX - strip.offsetLeft; scrollLeft = strip.scrollLeft;
  });
  window.addEventListener('mouseup', function(){ isDown = false; });
  strip.addEventListener('mousemove', function(e){
    if (!isDown) return;
    e.preventDefault();
    var x = e.pageX - strip.offsetLeft;
    strip.scrollLeft = scrollLeft - (x - startX) * 1.4;
  });
})();

// ---------- Product image gallery swap ----------
(function(){
  document.querySelectorAll('.gallery-strip').forEach(function(strip){
    var targetId = strip.dataset.mainTarget;
    var mainImg = targetId ? document.getElementById(targetId) : null;
    if (!mainImg) return;
    strip.querySelectorAll('button').forEach(function(btn){
      btn.addEventListener('click', function(){
        strip.querySelectorAll('button').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        mainImg.src = btn.dataset.img;
      });
    });
  });
})();

// ---------- Product quantity steppers ----------
(function(){
  document.querySelectorAll('[id^="qtyUp-"]').forEach(function(upBtn){
    var id = upBtn.id.replace('qtyUp-', '');
    var downBtn = document.getElementById('qtyDown-' + id);
    var valEl = document.getElementById('qtyVal-' + id);
    var input = document.getElementById('qtyInput-' + id);
    if (!valEl || !input) return;
    var qty = parseInt(input.value, 10) || 1;
    function sync(){ valEl.textContent = qty; input.value = qty; }
    upBtn.addEventListener('click', function(){ qty = Math.min(qty + 1, 99); sync(); });
    if (downBtn) downBtn.addEventListener('click', function(){ qty = Math.max(qty - 1, 1); sync(); });
  });
})();

// ---------- Product variant picker ----------
(function(){
  document.querySelectorAll('.pd-info[data-section-id]').forEach(function(pdInfo){
    var sectionId = pdInfo.dataset.sectionId;
    var variants = (window.__variants || {})[sectionId] || [];
    if (!variants.length) return;

    var sizeGrids = Array.from(pdInfo.querySelectorAll('.size-grid'));
    var variantInput = document.getElementById('variant-id-' + sectionId);
    var priceEl = document.getElementById('price-' + sectionId);
    var addBtn = document.getElementById('addBtn-' + sectionId);
    var mainImg = document.getElementById('mainImg-' + sectionId);

    function currentSelection(){
      var sorted = sizeGrids.slice().sort(function(a,b){
        return parseInt(a.dataset.optionIndex, 10) - parseInt(b.dataset.optionIndex, 10);
      });
      return sorted.map(function(grid){
        var active = grid.querySelector('button.active');
        return active ? active.dataset.value : null;
      });
    }

    function findVariant(selection){
      return variants.find(function(v){
        var opts = [v.option1, v.option2, v.option3];
        return selection.every(function(val, i){ return val === null || opts[i] === val; });
      });
    }

    function updateUI(){
      var match = findVariant(currentSelection());
      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (variantInput) variantInput.value = match.id;
      if (priceEl) {
        var html = match.priceHtml;
        if (match.comparePriceHtml) {
          html += ' <span style="text-decoration:line-through;opacity:0.5;font-size:0.85em;margin-left:8px;">' + match.comparePriceHtml + '</span>';
        }
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to Bag' : 'Sold Out';
      }
      if (mainImg && match.featuredImage) mainImg.src = match.featuredImage;
    }

    sizeGrids.forEach(function(grid){
      grid.querySelectorAll('button').forEach(function(btn){
        btn.addEventListener('click', function(){
          grid.querySelectorAll('button').forEach(function(b){ b.classList.remove('active'); });
          btn.classList.add('active');
          updateUI();
        });
      });
    });
  });
})();
